<form #newThemeForm="ngForm" (ngSubmit)="submit()">
  <vnm-form-field label="create-theme.name" info="create-theme.name-help">
    <input class="p-field-full-width" pInputText required name="name" type="text" [(ngModel)]="theme.name" />
  </vnm-form-field>

  <vnm-form-field label="create-theme.description">
    <input
      class="p-field-full-width"
      pInputText
      [required]="true"
      name="description"
      type="text"
      [(ngModel)]="theme.description"
    />
  </vnm-form-field>

  <vnm-form-field label="create-theme.base-theme" info="create-theme.base-theme-help">
    <p-dropdown
      name="event"
      [required]="true"
      [placeholder]="'create-theme.choose-theme' | translate"
      [options]="themes"
      optionLabel="name"
      styleClass="p-field-full-width"
      [(ngModel)]="base"
      appendTo="body"
    ></p-dropdown>
  </vnm-form-field>

  <vnm-form-actions direction="rtl" (cancel)="dialog.close()"></vnm-form-actions>
</form>
